// import * as React from "react";

// import Box from "@mui/material/Box";
// import Button from "@mui/material/Button";
// import Typography from "@mui/material/Typography";
// import {
//     TextField,
//     FormControl,
//     InputLabel,
//     Select,
//     MenuItem,
//     CircularProgress,
//     IconButton,
//     Stepper,
//     Step,
//     StepLabel,
//     Paper,
//     Chip,
//     Avatar,
//     Divider,
// } from "@mui/material";
// import { useTheme } from "@mui/material/styles";
// import useMediaQuery from "@mui/material/useMediaQuery";
// import { useEffect, useState, useRef } from "react";
// import Cookies from "js-cookie";
// import axios from "axios";
// import CancelIcon from "@mui/icons-material/Cancel";
// // import CustomizedDrawer from "../Email/CustomizedDrawer";
// // import { useConfirmation } from "../../context/ConfirmationDialogProvider";
// // import MessageStep from "./AddMessageSteppersCmp/MessageStep";

// const base_url = "http://api.virtualprachar.com/api/whatsapp/personal/group";
// const baseUrl =
//     "http://api.virtualprachar.com/api/whatsapp/personal/whatsapp_queue";

// const steps = ["Message", "Attachments", "Recipients"];

// const AttachmentStep = ({
//     image,
//     imgUrl,
//     btnLoading,
//     onImageChange,
//     onImageUpload,
//     onClearUploads,
//     fileInputRef,
// }) => {
//     return (
//         <Box sx={{ width: "100%", mb: 4 }}>
//             <Typography variant="h6" gutterBottom sx={{ mb: 2 }}>
//                 Upload Attachments (Optional)
//             </Typography>

//             <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
//                 <Button variant="contained" component="label">
//                     Select File
//                     <input
//                         type="file"
//                         hidden
//                         ref={fileInputRef}
//                         accept=".jpeg,.jpg,.png,.mp4,.pdf"
//                         onChange={onImageChange}
//                     />
//                 </Button>

//                 <Button
//                     variant="contained"
//                     disabled={image.length === 0 || btnLoading}
//                     onClick={onImageUpload}
//                 >
//                     Upload
//                     {btnLoading && (
//                         <CircularProgress size={24} sx={{ ml: 1 }} />
//                     )}
//                 </Button>
//             </Box>

//             {image.length > 0 && (
//                 <Paper
//                     sx={{
//                         p: 2,
//                         display: "flex",
//                         alignItems: "center",
//                         justifyContent: "space-between",
//                     }}
//                 >
//                     <Typography variant="body2">
//                         {image[0].name} {imgUrl && "(Uploaded)"}
//                     </Typography>
//                     <IconButton onClick={onClearUploads}>
//                         <CancelIcon color="error" />
//                     </IconButton>
//                 </Paper>
//             )}
//         </Box>
//     );
// };

// export default AttachmentStep;

import React from "react";
import {
    Box,
    Typography,
    Button,
    Paper,
    IconButton,
    CircularProgress,
} from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";

const AttachmentStep = ({
    image,
    imgUrl,
    btnLoading,
    onImageChange,
    onImageUpload,
    onClearUploads,
    fileInputRef,
    hasError,
}) => {
    return (
        <Box sx={{ width: "100%", mb: 4 }}>
            <Typography variant="h6" gutterBottom sx={{ mb: 2 }}>
                Upload Attachments (Optional)
            </Typography>

            <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
                <Button variant="contained" component="label">
                    Select File
                    <input
                        type="file"
                        hidden
                        ref={fileInputRef}
                        accept=".jpeg,.jpg,.png,.mp4,.pdf"
                        onChange={onImageChange}
                    />
                </Button>

                <Button
                    variant="contained"
                    disabled={image.length === 0 || btnLoading}
                    onClick={onImageUpload}
                >
                    Upload
                    {btnLoading && (
                        <CircularProgress size={24} sx={{ ml: 1 }} />
                    )}
                </Button>
            </Box>

            {image.length > 0 && (
                <Paper
                    sx={{
                        p: 2,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        border: hasError
                            ? "1px solid red"
                            : "1px solid rgba(0,0,0,0.23)",
                    }}
                >
                    <Typography variant="body2">
                        {image[0].name} {imgUrl && "(Uploaded)"}
                    </Typography>
                    <IconButton onClick={onClearUploads}>
                        <CancelIcon color="error" />
                    </IconButton>
                </Paper>
            )}

            {hasError && (
                <Typography
                    variant="caption"
                    color="error"
                    sx={{ mt: 1, display: "block" }}
                >
                    Please provide either a message or upload a file
                </Typography>
            )}
        </Box>
    );
};

export default AttachmentStep;
